import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./valuation-block-agriculture-activities.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./valuation-block-agriculture-activities.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { of } from "rxjs";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ValuationBlockAgricultureActivitiesService } from "./shared/services/valuation-block-agriculture-activities.service";
import { ValuationBlockAgricultureActivitiesConstants } from "./valuation-block-agriculture-activities.constants";
import { ValuationBlockAgricultureActivitiesConfigHeadingLookup } from "./shared/enums/pv-valuation-block-agriculture-activity.enum";
let ValuationBlockAgricultureActivityComponent = class ValuationBlockAgricultureActivityComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    changeDetectorRef;
    valuationBlockAgricultureActivitiesService;
    appControllerService;
    modalService;
    dataSource;
    selectedAgricultureActivitiesOnTheTable;
    tableMapper;
    addLabel = SharedConstants.ADD_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    agricultureActivitiesObjectName = ValuationBlockAgricultureActivitiesConstants.AGRICULTURE_ACTIVITIES_OBJECT_NAME;
    factorAdjustmentSuccessfullyInheritedMsg = ValuationBlockAgricultureActivitiesConstants.FACTOR_ADJUSTMENT_SUCCESSFULLY_INHERITED_MSG;
    constructor(aflaModuleStrategyService, route, routerParamsService, changeDetectorRef, valuationBlockAgricultureActivitiesService, appControllerService, modalService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRef = changeDetectorRef;
        this.valuationBlockAgricultureActivitiesService = valuationBlockAgricultureActivitiesService;
        this.appControllerService = appControllerService;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initializeColumnToObjectMapping();
    }
    ngAfterViewInit() {
        this.getValuationBlockId();
    }
    arrayReturned(array) {
        this.selectedAgricultureActivitiesOnTheTable = array;
    }
    handleRouteChange() {
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationBlockAgricultureActivitiesConfigHeadingLookup;
    }
    getValuationBlockId() {
        const params = {
            $expand: "agriculturalActivities",
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID} and deleted eq false`,
        };
        this.valuationBlockAgricultureActivitiesService
            .getValuationBlock(params)
            .subscribe({
            next: (response) => {
                if (response && response.length > 0) {
                    const activities = response[0].agriculturalActivities;
                    const switched = of(activities.sort((a, b) => 0 - ((a.method.toLowerCase() + a.activity.toLowerCase()) > (b.method.toLowerCase() + b.activity.toLowerCase()) ? -1 : 1)));
                    this.dataSource = switched;
                    this.changeDetectorRef.markForCheck();
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.agricultureActivitiesObjectName, error, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: ValuationBlockAgricultureActivitiesService },
        { type: AppControllerService },
        { type: NgbModal }
    ];
};
ValuationBlockAgricultureActivityComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-valuation-block-agriculture-activities",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ValuationBlockAgricultureActivityComponent);
export { ValuationBlockAgricultureActivityComponent };
